import { fromJS, List, Map } from 'immutable';

export function request(state) {
    return state.set('state', 'IN_PROGRESS');
}

export function finish(state, { id, data }) {
    return state
        .mergeIn([ 'items', '' + id ], data)
        .set('state', 'FINISHED');
}

export function error(state) {
    return state.set('state', 'ERROR');
}
